/** 样式 */
<style lang="scss" src="./BimEngineeringChangeTree.vue.scss"></style>
<template>
  <div class="bimEngineeringChangeTree" style="">
    <TreeFilter
      treeRef="transformDataTree"
      class="tree-view structure-tree"
      placeholder="请输入关键字"
      icon="el-icon-search"
    ></TreeFilter>
    <el-scrollbar style="height: 419.3px;">
      <el-tree
        node-key
        ref="transformDataTree"
        empty-text="数据为空"
        check-strictly
        :data="treedata"
        :props="defaultProps"
        :filter-node-method="filterNode"
        @node-click="handleNodeClick"
      >
        <div slot-scope="{ data }" class="custom-tree-node">
          <div class="item-tooltip" v-if="data.transformType === 'directory'">
            <span class="add-f-s-14"
              ><i class="el-icon-biangengguanli"></i>{{ data.text }}</span
            >

            <div class="operation-view">
              <!-- <i
              class="small-operation-btn el-icon-edit"
              @click.stop="theEditor(data)"
            />
            <i
              class="small-operation-btn el-icon-delete"
              @click.stop="handleDelete(data)"
            /> -->
              <i
                class="small-operation-btn el-icon-document"
                @click.stop="showInfo(data, 1)"
              />
            </div>
          </div>
          <div class="item-tooltip" v-else>
            <span class="add-f-s-14"
              ><i class="el-icon-paperclip" @click="theEditor(data)"></i
              >{{ data.text }}</span
            >

            <div class="operation-view">
              <i
                class="small-operation-btn el-icon-edit"
                @click.stop="theEditor(data)"
              />
              <i
                class="small-operation-btn el-icon-delete"
                @click.stop="handleDelete(data)"
              />
              <i
                class="small-operation-btn el-icon-xiangqing"
                @click.stop="showInfo(data, 2)"
              />
            </div>
          </div>
        </div>
      </el-tree>
    </el-scrollbar>

    <!-- <BimEngineeringChangeItemDetail
      ref="BimEngineeringChangeItemDetail"
      :showType="showInfoType"
    ></BimEngineeringChangeItemDetail> -->
  </div>
</template>
<script>
let graphicLayer, TilesetLayer; //展示线标记和面标记功能临时用。
/* 异步加载 一些弹窗组件 */
const TreeFilter = () => import("@/components/common/tree/Filter");
// const BimEngineeringChangeItemDetail = () =>
//   import(
//     "../bimEngineeringChangeItemDetail/BimEngineeringChangeItemDetail.vue"
//   );
//按需加载
import {
  getBimEngineeringChange,
  deleteBimEngineeringChangeItem,
  getBimengineeringchangeitemdetail,
  getFileList,
} from "../../../../api/api";
import { EventBus } from "../../../../static/js/event-bus.js";
export default {
  components: { TreeFilter },
  props: ["theEditor", "infoList", "showInfoType"],
  data() {
    return {
      treedata: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  computed: {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {
    //一个对象，键是需要观察的表达式，值是对应回调函数。
    //值也可以是方法名，或者包含选项的对象。
    //Vue 实例将会在实例化时调用 watch()，遍历 watch 对象的每一个 property。
  },
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
    this.initTreeData();
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  mounted() {
    //实例被挂载后调用，这时 el 被新创建的 vm.el 替换了。如果根实例挂载到了一个文档内的元素上，
    //当 mounted 被调用时 vm.el 也在文档内。
    graphicLayer = new mars3d.layer.GraphicLayer();
    this.$GLOBAL.map.addLayer(graphicLayer);

    EventBus.$on("updateCartesian", (param) => {
      //当标记点移动时，根据标记的id获取到标记的表单信息并显现在表单上，方便准确定位和编辑、更新等。

      // this.$refs.bimEngineeringChangeItem.form.position = param.cartesianXYZ; //这行代码不应该写在这里，因为如果只加载了TransformList弹窗，还没有加载BimEngineeringChangeItem弹窗，那么这段代码应该会报出this.$refs.bimEngineeringChangeItem未定义之类的错误。

      //根据编辑对象的id找到对应标记列表里的数据项，对应进行编辑。
      let tempData = "";
      if (param.mType === "point") {
        tempData = param.cartesianXYZ;
      } else if (param.mType === "polyline" || param.mType === "polygon") {
        tempData = param.points;
      }
      if (tempData) {
        this.editBimEngineeringChangeItemByUid(
          param.mType,
          param.graphic.uuid,
          tempData
        );
      }
    });
  },

  methods: {
    // 树形数据请求
    // 初始化列表
    initTreeData() {
      let tempdata = [];
      let modelData = {
        ProjectId: window.sessionStorage.getItem("nowProjectId"),
      };
      getBimEngineeringChange(modelData).then((res) => {
        tempdata = res.data.data;
        //console.log(res.data.data);
        tempdata.forEach((item) => {
          //console.log(item);
          if (item["children"] != null && item["children"].length > 0) {
            item["transformType"] = "directory";
          }

          item.children.forEach((i) => {
            //console.log(i);
          });
          this.treedata = tempdata;
        });
      });
    },
    // 搜索框
    filterNode(value, data, node) {
      if (!value) {
        //如果数据为空，则返回true,显示所有的数据项
        node.expanded = true;
        return true;
      } // 查询列表是否有匹配数据，将值小写，匹配英文数据
      let val = value.toLowerCase();
      return this.chooseNode(val, data, node); // 调用过滤二层方法
    },
    chooseNode(value, data, node) {
      if (data.text.toLowerCase().indexOf(value) !== -1) {
        return true;
      }
      const level = node.level;
      // 如果传入的节点本身就是一级节点就不用校验了
      if (level === 1) {
        return false;
      }
      // 先取当前节点的父节点
      let parentData = node.parent;
      // 遍历当前节点的父节点
      let index = 0;
      while (index < level - 1) {
        // 如果匹配到直接返回，此处name值是中文字符，enName是英文字符。判断匹配中英文过滤
        if (parentData.data.text.indexOf(value) !== -1) {
          return true;
        }
        // 否则的话再往上一层做匹配
        parentData = parentData.parent;
        index++;
      }
      // 没匹配到返回false
      return false;
    },
    // // 上传表单列表查询
    getListData(id) {
      let tileList = [];
      let modelData = {
        businessId: id,
        businessType: "BimEngineeringChangeItem",
      };
      getFileList(modelData).then((res) => {
        //console.log("测试", res.data.data);
        if (res.data.success && res.data.data.length > 0) {
          for (let i = 0; i < res.data.data.length; i++) {
            let tempObj = {
              name: res.data.data[i].fileOriginName,
              //如果要预览文件或下载文件则调用专门的api接口，因此这里不需要拼接出url。
              url: "#",
              id: res.data.data[i].id,
              //'url': process.env.VUE_APP_BASE_API + response.imgUrl
            };
            //console.log(tempObj);
            tileList.push(tempObj);
          }
          //console.log(tileList);
          this.fileList = tileList;
        }
      });
    },
    // 变更详情弹框
    showInfo(data, index) {
      //console.log("测试弹窗详情111");
      //this.getListData(data.id);
      //console.log(data);
      this.infoList(data);
      // this.onlyOneTab = true;
      // console.log("初始化类型：", 0);
      // let modelData = {
      //   ProjectId: data.bimEngineeringChangeItem.projectId,
      //   ItemId: 287425227132997, //this.faData.bimEngineeringChangeItem.id
      //   Type: 0,
      // };
      // getBimengineeringchangeitemdetail(modelData).then((res) => {
      //   console.log("详情列表数据", res.data);
      //   // this.attribute_data = res.data;
      // });
    },
    // 删除变更项
    handleDelete(data) {
      //console.log("删除data", data);
      deleteBimEngineeringChangeItem(data).then((res) => {
        if (res.data.success && res.data.code === 204) {
          this.initTreeData();
          this.$notify({
            title: "已成功删除该变更项。",
            message: "",
            type: "success",
            duration: 960,
            offset: 320,
          });
        } else {
          this.$alert("删除该变更项失败了，请再试一次吧~", "删除失败", {
            confirmButtonText: "确定",
            type: "error",
            callback: (action) => {},
          });
        }
      });
    },
    // 树结点
    handleNodeClick(data) {
      //console.log("树结点", data);
      if (data.children != null && data.children.length != 0) {
        for (let y = 0; y < data.children.length; y++) {
          data.children[y].bimEngineeringChangeItem.url_z =
            y == 0
              ? `${this.$GLOBAL.projectBaseUrl}${this.$GLOBAL.modelBasePort}255513056948293/都安高速MBS工程项目/第T7标段/桥梁工程/马道大桥/tileset.json`
              : `${this.$GLOBAL.projectBaseUrl}${this.$GLOBAL.modelBasePort}255513056948293/都安高速MBS工程项目/第T7标段/桥梁工程/下河中桥/tileset.json`;

          this.mapData(data.children[y].bimEngineeringChangeItem, "jiowsd");
        }
      } else {
        // this.$GLOBAL.layer.GraphicLayer.clear();
        if (
          data.bimEngineeringChangeItem.name != null &&
          data.bimEngineeringChangeItem.name.indexOf("变更前") > -1
        ) {
          data.bimEngineeringChangeItem.url_z = `${this.$GLOBAL.projectBaseUrl}${this.$GLOBAL.modelBasePort}255513056948293/都安高速MBS工程项目/第T7标段/桥梁工程/马道大桥/tileset.json`;
          data.bimEngineeringChangeItem.position_z = {
            lng: 107.527727,
            lat: 26.103964,
            alt: 911.6,
          };
        } else {
          data.bimEngineeringChangeItem.url_z = `${this.$GLOBAL.projectBaseUrl}${this.$GLOBAL.modelBasePort}255513056948293/都安高速MBS工程项目/第T7标段/桥梁工程/下河中桥/tileset.json`;
          data.bimEngineeringChangeItem.position_z = {
            lng: 107.527727,
            lat: 26.103964,
            alt: 911.6,
          };
        }

        // data.bimEngineeringChangeItem.position_z = {};
        this.mapData(data.bimEngineeringChangeItem);
      }
      // //根据数据库加载出来的项目的标记数据显示到地图上。
    },
    mapData(data, z) {
      //console.log("3d数据", data.url_z);
      // const tiles3dLayer = new mars3d.layer.TilesetLayer({
      //   id: data.id,
      //   name: data.name,
      //   // url: data.newModel != "" ? data.newModel : data.oldModel,
      //   url: encodeURI(data.url_z),
      //   // maximumScreenSpaceError: 16,
      //   // maximumMemoryUsage: 2048,
      //   // dynamicScreenSpaceError: true,
      //   // cullWithChildrenBounds: false,
      //   // luminanceAtZenith: 0.6,
      //   // //  position: { lng: data.y, lat: data.x, alt: data.z },
      //   // // position: data.position_z,
      //   // // position: { lng: 107.527727, lat: 26.103964, alt: 911.6 },
      //   // // rotation: { z: 17.5 },
      //   // // 高亮时的样式
      //   // highlight: {
      //   //   // all: true, //全部整体高亮，false时是构件高亮
      //   //   type: mars3d.EventType.click, // 默认为鼠标移入高亮，也可以指定click单击高亮
      //   //   color: "rgba(0,0,0.0,0.5)",
      //   // },
      //   // popup: "all",
      //   flyTo: true,
      // });
      // const baseMaps = map.getBasemaps(true);
      let tilesetLayer = new mars3d.layer.TilesetLayer({
        //url: "//data.mars3d.cn/3dtiles/max-fsdzm/tileset.json",//经过测试，确实是模型方面的问题导致旋转功能不能正常运行。
        url: encodeURI(data.url_z),

        //maximumNumberOfLoadedTiles:5,
        //以下几个参数是为了让模型加载更快更清晰。
        maximumScreenSpaceError: 16, // 【重要】数值加大，能让最终成像变模糊

        maximumMemoryUsage: 512, // 【重要】内存建议显存大小的50%左右，内存分配变小有利于倾斜摄影数据回收，提升性能体验。这个参数默认是512，也即是当几何体和纹理资源大于512MB的时候，Cesium就会淘汰掉当前帧中没有visited的所有块，这个值其实很小，也是cesium为了避免资源占用过高的一个保障，不过上述我们也估算过最差情况下，没有做纹理crn压缩的情况下，这个值很容易被超过，导致很多人误以为cesium的淘汰没有效果。这个值如果设置的过小，导致cesium几乎每帧都在尝试淘汰数据，增加了遍历的时间，也同时增加了崩溃的风险。这个值如果设置的过大，cesium的淘汰机制失效，那么容易导致显存超过显卡内存，也会导致崩溃。这个值应该处于最差视角下资源占用 和 显存最大量之间。
        skipLevelOfDetail: true, //是Cesium在1.5x 引入的一个优化参数，这个参数在金字塔数据加载中，可以跳过一些级别，这样整体的效率会高一些，数据占用也会小一些。但是带来的异常是：1） 加载过程中闪烁，看起来像是透过去了，数据载入完成后正常。2，有些异常的面片，这个还是因为两级LOD之间数据差异较大，导致的。当这个参数设置false，两级之间的变化更平滑，不会跳跃穿透，但是清晰的数据需要更长，而且还有个致命问题，一旦某一个tile数据无法请求到或者失败，导致一直不清晰。所以我们建议：对于网络条件好，并且数据总量较小的情况下，可以设置false，提升数据显示质量。
        loadSiblings: true, // 如果为true则不会在已加载完模型后，自动从中心开始超清化模型
        cullRequestsWhileMoving: true,
        cullRequestsWhileMovingMultiplier: 10, //【重要】 值越小能够更快的剔除
        preferLeaves: true, //【重要】这个参数默认是false，同等条件下，叶子节点会优先加载。但是Cesium的tile加载优先级有很多考虑条件，这个只是其中之一，如果skipLevelOfDetail=false，这个参数几乎无意义。所以要配合skipLevelOfDetail=true来使用，此时设置preferLeaves=true。这样我们就能最快的看见符合当前视觉精度的块，对于提升大数据以及网络环境不好的前提下有一点点改善意义。
        progressiveResolutionHeightFraction: 0.5, //【重要】 数值偏于0能够让初始加载变得模糊
        dynamicScreenSpaceError: true, // true时会在真正的全屏加载完之后才清晰化模型
        preloadWhenHidden: false, //tileset.show是false时，也去预加载数据

        // maximumScreenSpaceError: 6, //为了看压平效果
        // maximumMemoryUsage: 2048, //为了看压平效果

        // 高亮时的样式
        // highlight: {
        // 	type: mars3d.EventType.click, // 默认为鼠标移入高亮，也可以指定click单击高亮
        // 	color: "#FF0000"
        // },
        //clampToGround:true,
        popup: "all",
        flyTo: true,
      });

      this.$GLOBAL.map.addLayer(tilesetLayer);
      // tilesetLayer.remove(true);
    },
    // destroyed() {
    //   alert(1);
    //   //this.$GLOBAL.map.removeLayer(tilesetLayer,true);

    //   //this.$GLOBAL.map.removeLayer(tilesetLayer,true);//测试模型时用
    //   if (!normalShutdown) {
    //     this.clearCrop();
    //   }
    //   this.$GLOBAL.map.removeLayer(tiles3dLayer, true);
    //   tiles3dLayer = null;
    // },
  },

  beforeUpdate() {
    //数据更新时调用，发生在虚拟 DOM 打补丁之前。这里适合在更新之前访问现有的 DOM，比如手动移除已添加的事件监听器。
    //该钩子在服务器端渲染期间不被调用，因为只有初次渲染会在服务端进行。
  },
  updated() {
    //由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    //当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
    //然而在大多数情况下，你应该避免在此期间更改状态。如果要相应状态改变，通常最好使用计算属性或 watcher 取而代之。
  },
  activated() {
    //被 keep-alive 缓存的组件激活时调用。
    //该钩子在服务器端渲染期间不被调用。
  },
  deactivated() {
    //被 keep-alive 缓存的组件停用时调用。
    //该钩子在服务器端渲染期间不被调用。
  },
  beforeUnmount() {
    //实例销毁之前调用。在这一步，实例仍然完全可用。
    //该钩子在服务器端渲染期间不被调用。
  },
  unmounted() {
    //实例销毁后调用。该钩子被调用后，对应 Vue 实例的所有指令都被解绑，所有的事件监听器被移除，所有的子实例也都被销毁。
    //该钩子在服务器端渲染期间不被调用。
  },
  errorCaptured() {
    //当捕获一个来自子孙组件的错误时被调用。
    //此钩子会收到三个参数：错误对象、发生错误的组件实例以及一个包含错误来源信息的字符串。
    //此钩子可以返回 false 以阻止该错误继续向上传播。
  },
};
</script>

<style lang="scss" scoped></style>
